
const Page404 = () => {
    return <h1>Page Not Found</h1>;
}

export default Page404;